module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/BANISHED_S01.ba580fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/BANISHED_S01.jpg
// module id = dCtk
// module chunks = 0